import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import newUserAppUrl from '../routing/newUserApp';
import urls from '../routing/urls';

import {
  getFacebookShareLink,
  getLinkedInShareLink,
  getTwitterShareLink,
  getWhatsAppShareLink,
} from './commonHelper.js';

export const useSocialShare = (id, opening, type) => {
  const { t } = useTranslation('common');

  return useCallback(
    (platform) => {
      let typeUrl;
      if (type === 'job') {
        typeUrl = newUserAppUrl + urls.jobDetail.replace(':jobId', id);
      } else if (type === 'company') {
        typeUrl = newUserAppUrl + urls.companyProfile.replace(':companyName', id);
      }
      if (!typeUrl) return;

      let url;
      let text;
      switch (platform) {
        case 'LinkedIn':
          url = getLinkedInShareLink(typeUrl);
          break;
        case 'Twitter':
          if (type === 'job') {
            text = t('socialShare.checkoutJobOpening', {
              title: opening.title,
              company: opening.organization_name,
            });
          } else {
            text = t('socialShare.checkoutCompanyOpening', { company: opening.name });
          }
          url = getTwitterShareLink(typeUrl, text);
          break;
        case 'Facebook':
          url = getFacebookShareLink(typeUrl);
          break;
        case 'WhatsApp':
          url = getWhatsAppShareLink(typeUrl);
          break;
        default:
          throw new Error('Invalid social media type');
      }

      setTimeout(() => {
        window.open(url, '_blank');
      }, 100);
    },
    [id, opening?.name, opening?.title, opening?.organization_name, type, t]
  );
};
